<template>
  <div
    v-show="shown"
    class="col-12 nopads"
  >
    <div class="d-flex flex-row w-100">
      <div
        class="order-text ps-2"
        :style="{width: '100%', minWidth: textColWidthPercentage + '%'}"
      >
        <div class="row col-12 !nopads">
          <div
            class="col-9 !nopads single-line"
            style="padding-left: 0"
          >
            <font-awesome-icon
              icon="caret-right"
              class="pointer ms-1"
              style="outline: none; width: 2.5em; height: 1.1em"
              :class="{ 'fa-rotate-90': assignmentsVisible }"
              @click.stop="toggleAssignments"
            />
            <span
              :id="'o_t'+orderObject.id"
              class="ms-2 pointer"
              @click.stop="$emit('showOrder', orderObject)"
            >
              {{ orderObject.id }} - {{ getCalendarOrderTitle(orderObject) }}
            </span>
          </div>
          <div class="d-flex col-3 nopads justify-content-end">
            <order-status-badge
              :item-id="orderObject.id"
              :status="orderObject.status"
              @order-status-changed="updateOrderStatus"
            />
          </div>
        </div>
      </div>
      <div style="display: inline-block;">
        <div
          id="timeline-container"
          style="display: flex;  position: relative"
        >
          <div
            v-for="(week, index) in weeks"
            :key="index"
            class="week-item"
            :style="{width: weekColWidth + 'px'}"
          >
            {{ '-' }}
          </div>
          <!-- Draggable and resizable time line for order schedule -->
          <time-line-item
            :item-id="orderObject.id"
            :time-col-width="weekColWidth"
            :timeline-start-date="new Date(calendarStartDate)"
            :calendar-start-week="calendarStartWeek"
            :calendar-start-date="new Date(calendarStartDate)"
            :visible-weeks-limit="visibleWeeksLimit"
            :color="orderObject.contract_task_type.task_type.color"
            :start-date="orderObject.planned_start ? getDateFromString(orderObject.planned_start) : null"
            :end-date="orderObject.planned_ready ? getDateFromString(orderObject.planned_ready) : null"
            @dates-changed="updateOrderDates"
          />
        </div>
      </div>
    </div>
    <div>
      <div v-show="assignmentsVisible">
        <div class="d-flex flex-row w-100">
          <div
            class="order-text"
            :style="{width: '100%', minWidth: textColWidthPercentage + '%', borderTop: 'none', paddingLeft: '5em' }"
          >
            <div
              class="row col-12"
            >
              {{ $t('calendar.ordered_amount') }}: {{ orderObject.ordered_amount ? orderObject.ordered_amount : 0 }}
              {{ orderObject.unit ? getUnitText(orderObject.unit) : null }}
            </div>
            <div
              v-if="orderObject.info"
              class="order-info"
            >
              {{ orderObject.info }}
            </div>
          </div>
          <div :style="{minWidth: vehicleCalendarChild ? '1127px' : '980px'}" />
        </div>
        <div class="d-flex flex-row w-100">
          <div
            class="order-text sub-item"
            :style="{width: '100%', minWidth: textColWidthPercentage + '%', color: '#636364', borderTop: 'none' }"
          >
            <div class="row !nopads">
              <div
                class="col-9 !nopads fw-bold"
                style="padding-left: 0;"
              >
                {{ $t('menu.work_assignment') }} ({{ assignments.length }})
              </div>
              <div class="col-3 !nopads text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-outline-secondary btn-sm dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                  <!--                  {{ $t('calendar.add_work_assignment_order') }}-->
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <button
                        class="dropdown-item"
                        @click.stop="emitAddAssignment"
                      >
                        {{ $t('calendar.add_work_assignment_order') }}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div style="display: inline-block;">
            <div
              id="timeline-container"
              style="display: flex; position: relative;"
            >
              <div
                v-for="(week, index) in weeks"
                :key="index"
                class="fill-item"
                :style="{ width: weekColWidth + 'px' }"
              >
                {{ '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Assignments -->
        <assignment-calendar-item
          v-for="assignment in assignments"
          :key="assignment.id"
          :assignment="assignment"
          :time-col-width="weekColWidth"
          :visible-weeks-limit="visibleWeeksLimit"
          :calendar-start-week="calendarStartWeek"
          :calendar-start-date="calendarStartDate"
          :text-col-width-percentage="textColWidthPercentage"
          :assignments-selected-limiter="assignmentFilter"
          @show-assignment="emitShowAssignment"
        />
      </div>
    </div>
  </div>
</template>


<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import TimeLineItem from "@/components/contractcalendar/TimeLineItem";
import {orderMixin} from "@/components/mixins/OrderMixin";
import OrderStatusBadge from "@/components/contractcalendar/OrderStatusBadge";
import {workAssignmentHelper} from "@/components/mixins/WorkAssignmentMixin";
import {workManagementHelper} from '@/components/mixins/WorkManagementMixin'
import AssignmentCalendarItem from "@/components/contractcalendar/AssignmentCalendarItem";
export default {
    name: 'OrderCalendarItem',
    components: {AssignmentCalendarItem, OrderStatusBadge, TimeLineItem},
    mixins: [timeUtils, restApi, orderMixin, workAssignmentHelper, workManagementHelper],
    props: {
        order: {
            type: Object,
            default: null
        },
        assignments: {
            type: Array,
            default() {
                return []
            }
        },
        vehicleCalendarChild: {
            type: Boolean,
            default: false
        },
        textColWidthPercentage: {
            type: Number,
            default: 40
        },
        assignmentFilter: {
            type: Array,
            default: null
        },
        selectedLimiter: {
            type: Array,
            default: null
        },
        timeColWidth: {
            type: Number,
            default: 100  // px
        },
        showAll: {
            type: Boolean,
            default: false
        },
        showAssignments: {
            type: Boolean,
            default: true
        },
        visibleWeeksLimit: {
            type: Number,
            default: 20
        },
        calendarStartWeek: {
            type: Number,
            default: 20
        },
        calendarStartDate: {
            type: Date,
            default: null
        }
    },
    data: function () {
        return {
            start: null,
            assignmentsVisible: false,
            loading: 0,
            orderObject: null,
            weeks: [],
            shown: false,
        }
    },
    computed: {
        status() {
            return status
        },
        weekColWidth() {
            return Math.round(this.timeColWidth / 7) * 7
        }
    },
    watch: {
        calendarStartWeek: function () {
            this.initTable()
        },
        order: function () {
            this.orderObject = this.order
        },
        selectedLimiter: function () {
            this.toggleShown()
        },
    },
    created: function () {
        this.orderObject = this.order
        this.initTable();
        if(this.showAll) {
            this.toggleAssignments()
        }
        this.toggleShown()
    },
    methods: {
        initTable() {
            this.weeks = []
            let startWeek = this.calendarStartWeek
            for (let i = 0; i < this.visibleWeeksLimit; i++) {
                this.weeks.push(this.$t('calendar.wk_prefix') + (startWeek+i))
            }
        },
        toggleShown(){
            if (this.selectedLimiter === null || this.selectedLimiter.length === 0) this.shown = true
            else {
                for (let i = 0; i < this.selectedLimiter.length; i++) {
                    this.selectedLimiter.includes(this.orderObject.status) ? this.shown = true : this.shown = false
                }
            }
        },
        toggleAssignments() {
            this.assignmentsVisible = !this.assignmentsVisible
        },
        updateOrderDates(orderId, startDate, endDate) {
            const orderStartDate = this.getDateIsoString(startDate)
            const orderEndDate = this.getDateIsoString(endDate)
            this.orderObject.planned_start = orderStartDate
            this.orderObject.planned_ready = orderEndDate
            this.restUpdate(this.orderDateUrl, {id: orderId, planned_start: orderStartDate, planned_ready: orderEndDate},
                this.orderUpdated, this.orderUpdateFailed)
        },
        updateOrderStatus(orderId, status) {
            this.orderObject.status = status
            this.restUpdate(this.orderStatusUrl, {id: orderId, status: status}, this.orderUpdated, this.orderUpdateFailed)
            this.toggleShown()
        },
        orderUpdated() {
            this.$emit('orderUpdated')
        },
        orderUpdateFailed() {
            // TODO - Show error message
        },
        emitShowAssignment(assignment) {
            this.$emit('showAssignment', assignment)
        },
        emitAddAssignment() {
            this.$emit('addAssignment', this.orderObject ? this.orderObject : null)
        }
    }
}
</script>
<style scoped>

.row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0;
}

.week-item, .order-text, .fill-item {
    display: inline-block;
    background: #ffffff;
    border-top: 1px #BCBCBC solid;
    border-right: 1px #BCBCBC solid;
    border-bottom: 1px #BCBCBC solid;
    margin: 0;
    padding: .1em;
    font-size: .9em;
    user-select: none;
    min-height: 2.3em;
}
.order-text {
    color: #404041;
    padding-left: 2.5em;
}
.sub-item {
    padding-left: 5em;
    color: #636364;
    font-size: .9em;
    font-weight: bold;
}
.week-item, .fill-item {
    color: #FFFFFF;
    user-select: none;
    padding: .1em;
}

.single-line {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.order-text:hover, .single-line:hover {
    color: #007BFF;
    font-weight: bold;
}
.dropdown-adder {
    padding-top: 0;
    padding-bottom: 0;
    max-height: 1.4em;
}
.btn-sm {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.order-info {
    font-size: .9em;
    padding-left: 2.7em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
